import { AppModule } from "@/store/modules/app";
import { ILaneSignalPhaseInfo } from "@/types/map";
import { loadModules } from "esri-loader";
import CrossSignalPhase2D from "./CrossSignalPhase2D";

export default class SignalPhaseController2D {
  private static intances: Map<string, SignalPhaseController2D>;

  public static getInstance(view: __esri.View) {
    const id = view.container.id;
    if (!SignalPhaseController2D.intances) {
      SignalPhaseController2D.intances = new Map();
    }
    let instance = SignalPhaseController2D.intances.get(id);
    if (!instance) {
      instance = new SignalPhaseController2D(view);
      SignalPhaseController2D.intances.set(id, instance);
    }
    return instance;
  }

  private view: __esri.View;

  private initialized = false;
  private phaseLineLayer!: __esri.FeatureLayer;
  private phaseLabelLayer!: __esri.FeatureLayer;
  private sideWalkLayer!: __esri.FeatureLayer;
  private crossMap: Map<string, CrossSignalPhase2D> = new Map();

  constructor(view: __esri.View) {
    this.view = view;
  }

  private async initialize() {
    const gisServerPrefix = `http://${AppModule.appConfig.gisServer}/arcgis/rest/services`;
    // const phaseLineLayerUrl = `https://${AppModule.appConfig.gisServer}/arcgis/rest/services/Shanghai_Road/FeatureServer/10`;
    const phaseLineLayerUrl = `${gisServerPrefix}/Unicron/ShangHai_Road/MapServer/10`;
    const phaseLabelLayerUrl = `${gisServerPrefix}/Unicron/ShangHai_Road/MapServer/9`;
    const sideWalkLayerUrl = `${gisServerPrefix}/Unicron/ShangHai_Road/MapServer/1`;

    type MapModules = [typeof import("esri/layers/FeatureLayer")];
    const [FeatureLayer] = await (loadModules([
      "esri/layers/FeatureLayer",
    ]) as Promise<MapModules>);
    this.phaseLineLayer = new FeatureLayer({
      url: phaseLineLayerUrl,
      outFields: ["*"],
    });
    this.phaseLabelLayer = new FeatureLayer({
      url: phaseLabelLayerUrl,
      outFields: ["*"],
    });
    this.sideWalkLayer = new FeatureLayer({
      url: sideWalkLayerUrl,
      outFields: ["*"],
    });

    this.initialized = true;
  }

  public async initializeCross(crossId: string): Promise<CrossSignalPhase2D> {
    let cross = this.crossMap.get(crossId);
    if (!cross) {
      cross = new CrossSignalPhase2D({
        crossId,
        phaseLineLayer: this.phaseLineLayer,
        phaseLabelLayer: this.phaseLabelLayer,
        sideWalkLayer: this.sideWalkLayer,
        view: this.view,
      });
      this.crossMap.set(crossId, cross);
    }

    await cross.initializeCross();
    return cross;
  }

  public async startLaneSignalPhase(
    laneSignalPhaseInfos: ILaneSignalPhaseInfo[]
  ) {
    if (!this.initialized) {
      await this.initialize();
    }
    // 处理车道数据，按路口分成单条数据
    const crossSignalPhaseData: Map<string, ILaneSignalPhaseInfo[]> = new Map();
    laneSignalPhaseInfos.forEach((laneSignalPhaseInfo) => {
      const laneIds = laneSignalPhaseInfo.laneIds;
      const laneIdArray = laneIds.split(",");
      laneIdArray.forEach((laneId) => {
        const crossId = this.getCrossIdFromLaneId(laneId);
        const signalPhaseInfos = crossSignalPhaseData.get(crossId);
        if (signalPhaseInfos) {
          signalPhaseInfos.push({ ...laneSignalPhaseInfo, laneIds: laneId });
        } else {
          crossSignalPhaseData.set(crossId, [
            { ...laneSignalPhaseInfo, laneIds: laneId },
          ]);
        }
      });
    });

    crossSignalPhaseData.forEach(async (signalPhaseInfos, crossId) => {
      const cross = await this.initializeCross(crossId);
      cross.setLaneSignalPhaseInfos(signalPhaseInfos);
    });
  }

  private getCrossIdFromLaneId(laneId: string): string {
    const laneIdParams = laneId.split("-");
    return laneIdParams[0].trim();
  }

  public stopLaneSignalPhase(crossId: string) {
    const cross = this.crossMap.get(crossId);
    if (cross) {
      cross.stopLaneSignalPhase();
    }
  }

  public stopAllLaneSignalPhase() {
    for (let cross of this.crossMap.values()) {
      cross.stopLaneSignalPhase();
    }
  }
}
